<template>
  <div class="button pl-2">
    <div class="row mt-3" style="padding-left: 2%;">
      <div class="col-12">

          <span v-if="baseUrl" class="text-secondary text-uppercase" :href="baseUrl" >
            {{ specialgroup ? specialgroup : 'Catalogue' }}
          </span>
          

          <a v-if="section && section.name && section.seoName" class="text-secondary" :href=" baseUrl + '/' + section.seoName" >
            <span v-if="baseUrl" >/</span>
            {{ section.name }}
          </a>
         
          <a  v-if="section && section.seoName && group && group.name && group.seoName" class="text-secondary" :href="baseUrl + '/' + section.seoName + '/' + group.seoName " >
            <span v-if="section && section.name && section.seoName" >/</span>
            {{ group.name }}
          </a>

          

          <a v-if="section && section.seoName && group && group.name && group.seoName && subGroup && subGroup.name && subGroup.seoName" class="text-secondary" :href="baseUrl + '/' + section.seoName + '/' + group.seoName + '/' + subGroup.seoName " >
            <span v-if="subGroup">/</span>
            {{ subGroup.name }}
          </a>

      </div>

    </div>
  </div>
</template>
<script>
export default {
    props: {

      baseUrl: {
        type: String,
        default: '/catalogue'
      },

      specialgroup:{
          type:String,
          default:null
      },

      section:{
          type:Object,
          default:null
      },
      group:{
          type:Object,
          default:null
      },
      subGroup:{
          type:Object,
          default:null
      },
    },

  }
</script>

<style scoped>

.button {
  position: relative;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  font-family: 'Space Grotesk';
  color: #828282;
}
</style>